import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import {
  RevisionHistoryActionButton,
  RevisionHistoryActionContext
} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';
import { DeleteRevisionAction } from '~src/revisionHistory/services/DeleteRevisionAction';
import { RevisionActions } from '~src/revisionHistory/services/RevisionActions';
import { UpdateRevisionNotesAction } from '~src/revisionHistory/services/UpdateRevisionNotesAction';
import { IWorkbookRevision } from '~src/revisionHistoryWorkbook/serverApi/types/IWorkbookRevision';

import { PreviewWorkbookRevisionActionInstance } from '../services/PreviewWorkbookRevisionAction';


export namespace RevisionActionWorkbook {

  export function getWorkbookRevisionActionButtons(): RevisionHistoryActionButton<IWorkbookRevision>[] {
    const actions = [
      previewWorkbookRevisionAction(),
      deleteWorkbookRevisionAction(),
      RevisionActions.downloadContentRevisionAction()
    ];
    if (FeatureFlags.enablePublishRevisionNotes) {
      actions.push(updateWorkbookRevisionNotesAction());
    }
    return actions;
  }

  // action button factories
  function previewWorkbookRevisionAction(): RevisionHistoryActionButton<IWorkbookRevision> {
    return {
      name: 'preview',
      translate: 'preview_action',
      execute: (context: RevisionHistoryActionContext<IWorkbookRevision>) => {
        PreviewWorkbookRevisionActionInstance.openPreview(context.selectedItem);
      }
    };
  }

  function deleteWorkbookRevisionAction(): RevisionHistoryActionButton<IWorkbookRevision> {
    return {
      name: 'delete',
      translate: 'delete_action',
      execute: (context: RevisionHistoryActionContext<IWorkbookRevision>) => {
        DeleteRevisionAction.showDeleteWorkbookRevisionDialog(context.selectedItem, context);
      }
    };
  }

  function updateWorkbookRevisionNotesAction(): RevisionHistoryActionButton<IWorkbookRevision> {
    return {
      name: 'updateNotes',
      translate: 'revisionNotesDialogTitle',
      execute: (context: RevisionHistoryActionContext<IWorkbookRevision>) => {
        UpdateRevisionNotesAction.showUpdateWorkbookRevisionNotesDialog(context.selectedItem, context);
      }
    };
  }
}
